<template>
  <v-card class="text-center" flat tile>
    <v-badge bordered inline color="transparent" offset-x="10" offset-y="10">
      m<sup>2</sup> x <Paleta class="ml-1 mr-1" /> 
    </v-badge>
  </v-card>
</template>

<script>
import { Paleta } from "../Icons";

export default {
  components: { Paleta },
};
</script>

<style></style>
